import { checkPermissionsMixin } from "../checkPermissionsMixin";

export const managementViewMixin = {
  mixins: [checkPermissionsMixin],

  // computed: {
  //   roleManagementPermissions() {
  //     return this.$store.getters.userPermissionsByRole("management");
  //   }
  // },

  methods: {
    isMenuEnabled(menu) {
      let submenus = menu.submenu;
      for (let submenu of submenus) {
        if (!submenu.disabled) {
          return true;
        }
      }
      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/management/managementViewMixin.js